import { createModel } from '@rematch/core';
import { db } from 'configs/constants';
import { EVENTCODE } from 'configs/active/constants';
import { IConfig, ITeam } from 'configs/interfaces';
import { onSnapshot, doc, collection, where, query, Unsubscribe } from 'firebase/firestore';

import type { RootModel } from '.';

const ZEROHOUR = '2020-01-01T12:00:00.094Z';

type IDefaultState = {
	teams: ITeam[];
	teamsSync?: Unsubscribe;
	lastTeamsRead: string;
	config?: IConfig;
	configSync?: Unsubscribe;
};

export const data = createModel<RootModel>()({
	state: {
		teams: [],
		teamsSync: undefined,
		lastTeamsRead: ZEROHOUR,
		config: undefined,
		configSync: undefined,
	} as IDefaultState,
	reducers: {
		addTeams(state, teams: IDefaultState['teams']) {
			const _teams = state.teams ? [...state.teams] : [];
			let lastRead = state.lastTeamsRead ?? ZEROHOUR;
			teams.forEach((team) => {
				const idx = _teams.findIndex((e) => e.id === team.id);
				if (idx !== -1) {
					if (team.isDeleted) {
						_teams.splice(idx, 1);
					} else {
						_teams[idx] = team;
					}
				} else if (!team.isDeleted) {
					_teams.push(team);
				}
				if (lastRead < team.updated_at) {
					lastRead = team.updated_at;
				}
			});

			return {
				...state,
				teams: _teams,
				lastTeamsRead: lastRead,
			};
		},
		setTeamsSync(state, teamsSync: IDefaultState['teamsSync']) {
			return {
				...state,
				teamsSync,
			};
		},
		setConfig(state, config: IDefaultState['config']) {
			return {
				...state,
				config,
			};
		},
		setConfigSync(state, configSync: IDefaultState['configSync']) {
			return {
				...state,
				configSync,
			};
		},
	},
	effects: (dispatch) => ({
		startConfigSync(payload, store) {
			try {
				if (!store.data.configSync) {
					const sync = onSnapshot(doc(db, `${EVENTCODE}/config`), (doc) => {
						const data = doc.data() as IDefaultState['config'];

						dispatch.data.setConfig(data);
					});
					dispatch.data.setConfigSync(sync);
				}
			} catch (error) {
				console.log('startConfigSync', error);
			}
		},
		stopConfigSync(payload, store) {
			try {
				if (store.data.configSync) {
					store.data.configSync();
					dispatch.data.setConfigSync(undefined);
				}
			} catch (error) {
				console.log('stopConfigSync', error);
			}
		},
		startTeamsSync(payload, store) {
			try {
				if (!store.data.teamsSync) {
					// const lastRead = store.data.lastTeamsRead ?? ZEROHOUR;
					const lastRead = ZEROHOUR;
					const q = query(collection(db, `${EVENTCODE}/data/team`), where('updated_at', '>=', lastRead));
					const sync = onSnapshot(q, (querySnapshot) => {
						const _teams: ITeam[] = [];
						querySnapshot.forEach((doc) => {
							const data = doc.data() as ITeam;
							_teams.push(data);

							dispatch.data.addTeams(_teams);
						});

						dispatch.data.addTeams(_teams);
					});

					dispatch.data.setTeamsSync(sync);
				}
			} catch (error) {
				console.log('startTeamsSync', error);
			}
		},
		stopTeamsSync(payload, store) {
			try {
				if (store.data.teamsSync) {
					store.data.teamsSync();
					dispatch.data.setTeamsSync(undefined);
				}
			} catch (error) {
				console.log('stopTeamsSync', error);
			}
		},
	}),
});
